// DOLPHIN
export const UPDATE_DOLPHIN_LONGSENT = 'UPDATE_DOLPHIN_LONGSENT';

export const UPDATE_DOLPHIN_SUBJECT = 'UPDATE_DOLPHIN_SUBJECT';

export const UPDATE_DOLPHIN_AUDIOBLOBURL = 'UPDATE_DOLPHIN_AUDIOBLOBURL';

export const UPDATE_DOLPHIN = 'UPDATE_DOLPHIN';
